import { indexItems } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200/60' },
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200/60' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200/60' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">主题索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">按题材探索你喜欢的耽耽漫画，海量分类精准直达</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-5">
          {indexItems.map((item, i) => {
            const c = colorMap[item.color] || colorMap.primary;
            return (
              <a
                key={item.id}
                href="#ranking"
                className={`group relative ${c.bg} rounded-xl md:rounded-2xl p-4 md:p-6 border ${c.border} hover:scale-[1.02] transition-all duration-300 cursor-pointer`}
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${c.bg} flex items-center justify-center mb-3 md:mb-4`}>
                  <i className={`${item.icon} ${c.text} text-xl md:text-2xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-2">{item.desc}</p>
                <span className={`text-xs font-medium ${c.text}`}>{item.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}